import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSkeletons = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 5.292 5.292",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 1.5,
		strokeWidth: 1.096,
		clipRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: .656,
				d: "M1422.74 917.11h10.45",
				transform: "matrix(.19398 0 0 .30212 -275.114 -274.431)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: .53,
				d: "m1426.4 919.248 4.95-5.418",
				transform: "matrix(.30119 .01621 -.0073 .29736 -420.01 -293.824)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				strokeWidth: .829,
				d: "M2.495 2.247h.8v.8h-.8zM.467 2.247h.8v.8h-.8zM4.025.716h.8v.8h-.8z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "none",
				stroke: "currentColor",
				strokeWidth: .53,
				d: "m1426.4 919.248 4.95-5.418",
				transform: "matrix(.30119 -.01621 -.0073 -.29736 -420.01 299.116)"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "currentColor",
				strokeWidth: .829,
				d: "M4.025 4.575h.8v-.8h-.8z"
			})
		]
	})
});
export default SvgIconSkeletons;
